import React from 'react';
import { Render } from '../platformui/';
import IntroBlock from '../components/c-intro-theme';
export default (props) => (
  <IntroBlock
    {...props}
    Heading={Render.Property(props.Heading, 'Heading')}
    HeadingTranslation={props.CurrentPageProps.Content.HeadingTranslation}
    Preamble={Render.Property(props.Preamble, 'Preamble')}
  />
);
